var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m31.882 26.097.992-6.466H26.67v-4.196c0-1.769.866-3.493 3.645-3.493h2.821V6.437S30.576 6 28.129 6c-5.11 0-8.45 3.097-8.45 8.703v4.928H14v6.466h5.68v15.631a22.5 22.5 0 0 0 6.99 0v-15.63z"
  })));
};
export default SvgFacebook;